//@ts-check

class DashboardService {
    constructor($http, $filter, Utility, $timeout, LocalStorageService, InternalLinksService) {
        this.$http = $http;
        this.$filter = $filter;
        this.Utility = Utility;
        this.$timeout = $timeout;
        this.LocalStorageService = LocalStorageService;
        this.InternalLinksService = InternalLinksService;
    }

    async getPayments(schemeRef) {
        let promise;
        let promiseHandler = {};

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!!!schemeRef) {
                throw Error('The Scheme Reference was not supplied.');
            }

            let url = await this.InternalLinksService.getLink('PaymentsForDashboard');
            if (!url) {
                await this.InternalLinksService.getLinks('api/payments/links');
                url = await this.InternalLinksService.getLink('PaymentsForDashboard');
            }

            const noOfPayments = 3,
                headers = this.Utility.headersWithContentType;

            url = url.replace('{schemeRef}', schemeRef);
            url += `?noOfPayments=${noOfPayments}`;

            const results = await this.$http.get(url, { headers });
            const { data } = this._mapPayments(results);
            const { WasSuccessful } = data;

            if (WasSuccessful) {
                this.$timeout(() => {
                    promiseHandler.resolve(data);
                });
            } else {
                throw new Error('There are no payments awaiting approval.');
            }
        } catch (err) {
            this.$timeout(() => {
                promiseHandler.reject(err);
            });
        }

        return promise;
    }

    async getAccountHistory(cardCard) {
        let promise;
        let promiseHandler = {};

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('AccountHistoryForDashboard');
            if (!url) {
                await this.InternalLinksService.getLinks('api/accounts/links');
                url = await this.InternalLinksService.getLink('AccountHistoryForDashboard');
            }

            const noOfMonthsHistory = 3;
            const headers = this.Utility.headersWithContentType;

            url = url.replace('{cardCode}', cardCard);
            url += `?noOfMonthsHistory=${noOfMonthsHistory}`;

            const results = await this.$http.get(url, { headers });
            let { data } = results;
            data = this._mapAccountHistory(data);

            this.$timeout(() => {
                promiseHandler.resolve(data);
            });
        } catch (err) {
            this.$timeout(() => {
                promiseHandler.reject(err);
            });
        }

        return promise;
    }

    async getMasterEmail(userName) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('GetMasterEmailByUserNameLink');
            if (!url) {
                await this.InternalLinksService.getLinks('api/accounts/links');
                url = await this.InternalLinksService.getLink('GetMasterEmailByUserNameLink');
            }

            url = url.replace('{userName}', userName);

            const headers = this.Utility.headersWithContentType;

            const results = await this.$http.get(url, { headers });

            let email;
            if ('data' in results) {
                const { data: emailResults } = results;
                email = emailResults;
            } else {
                throw new Error('Error while loading profile details.');
            }
            promiseHandler.resolve(email);
        } catch (error) {
            promiseHandler.reject(error);
        }

        return promise;
    }

    async getUserUnitsInformation(schemeRef, email) {
        let promise, promiseHandler;

        promise = new Promise((resolve, reject) => {
            promiseHandler = {
                reject,
                resolve
            };
        });

        try {
            if (!!!schemeRef) {
                throw new Error('scheme Reference must be specified.');
            }

            let url = await this.InternalLinksService.getLink('LoadUserUnitsLink');
            if (!url) {
                await this.InternalLinksService.getLinks('api/dashboard/links');
                url = await this.InternalLinksService.getLink('LoadUserUnitsLink');
            }

            if (!!!email) {
                throw new Error('Username must be provided...');
            }

            if (typeof schemeRef === 'object') {
                schemeRef = schemeRef.SchemeReference;
            }

            url = url.replace('{schemeRef}', schemeRef);
            const headers = this.Utility.headersWithContentType;

            url = `${url}?username=${email}`;

            var results = await this.$http.get(url, { headers });
            let Data;
            if ('data' in results) {
                const { data: rawData } = results;
                Data = rawData;
            } else {
                Data = results;
            }
            const { Data: data, WasSuccessful: wasSuccessful } = Data;

            if (!wasSuccessful) {
                throw new Error('Error while loading user units.');
            }

            promiseHandler.resolve(data);
        } catch (error) {
            promiseHandler.reject(error);
        }

        return promise;
    }

    async getBuildingUtilityInformation(schemeRef) {
        let promise, promiseHandler;

        promise = new Promise((resolve, reject) => {
            promiseHandler = {
                reject,
                resolve
            };
        });

        try {
            if (!!!schemeRef) {
                throw new Error('scheme Reference must be specified.');
            }

            let url = await this.InternalLinksService.getLink('LoadUtilitiesLink');
            if (!url) {
                await this.InternalLinksService.getLinks('api/dashboard/links');
                url = await this.InternalLinksService.getLink('LoadUtilitiesLink');
            }

            url = url.replace('{schemeRef}', schemeRef);
            const headers = this.Utility.headersWithContentType;

            var results = await this.$http.get(url, { headers });

            let Data;
            if ('data' in results) {
                const { data: rawData } = results;
                Data = rawData;
            } else {
                Data = results;
            }
            const { Data: data, WasSuccessful: wasSuccessful } = Data;

            if (!wasSuccessful) {
                throw new Error('Error while loading utilities.');
            }

            promiseHandler.resolve(data);
        } catch (error) {
            promiseHandler.reject(error);
        }

        return promise;
    }

    _getSelectedBuildingRef() {
        let schemeRef = this.LocalStorageService.retrieve('selectedBuildingRef');
        if (typeof schemeRef === 'object') {
            schemeRef = schemeRef.SchemeReference;
        }
        if (!schemeRef) {
            let selectedBuildingRefQueryString = this.Utility.QueryString('DBRef');
            if (selectedBuildingRefQueryString) {
                this.selectedBuildingRef = selectedBuildingRefQueryString.toUpperCase();
                schemeRef = this.selectedBuildingRef;
            }
        }

        return schemeRef;
    }

    _mapPayments(original) {
        let mapped = original;
        let { data } = original;
        let { Data } = data;

        Data = Data.map((payment) => {
            return {
                title: payment.ServiceProviderName,
                value: payment.Amount
            };
        });

        data.Data = Data;

        mapped = {
            ...original,
            data
        };

        return mapped;
    }

    _mapAccountHistory(original) {
        const mappedAmount = this.$filter('number', 2)(original.CurrentBalance);
        let mapped = {
            front: {
                title: ['Account Balance', original.UnitFriendlyName],
                value: `R ${mappedAmount}`
            },
            back: {
                value: original.AccountHistorySummaries.map((summary) => {
                    return {
                        title: summary.Description,
                        value: summary.TotalCharged
                    };
                })
            }
        };

        return mapped;
    }
}

export default /* @ngInject */ ($http, $filter, Utility, $timeout, LocalStorageService, InternalLinksService) =>
    new DashboardService($http, $filter, Utility, $timeout, LocalStorageService, InternalLinksService);
